import { render } from "./HomeView.vue?vue&type=template&id=5d9cc898&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=5d9cc898&scoped=true&lang=scss"

import exportComponent from "/builds/blat/bcard-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9cc898"]])

export default __exports__